import React from 'react';
import { Trash2, Check } from 'lucide-react';
import RedactionReasonSelect from './RedactionReasonSelect';

const RedactionMarkList = ({ marks, reasonCodes, onUpdateMark, onDeleteMark, onSelectMark, selectedMarkId }) => {
  // Group marks by page
  const marksByPage = {};
  marks.forEach((mark) => {
    if (!marksByPage[mark.page_number]) {
      marksByPage[mark.page_number] = [];
    }
    marksByPage[mark.page_number].push(mark);
  });

  const sortedPages = Object.keys(marksByPage)
    .map(Number)
    .sort((a, b) => a - b);

  if (marks.length === 0) {
    return (
      <div className="p-4 text-center text-sm text-gray-500">
        No redaction marks yet. Draw rectangles on the document or use auto-detect.
      </div>
    );
  }

  return (
    <div className="overflow-y-auto">
      {sortedPages.map((pageNum) => (
        <div key={pageNum}>
          <div className="sticky top-0 bg-gray-100 px-3 py-1.5 text-xs font-semibold text-gray-600 border-b">
            Page {pageNum} ({marksByPage[pageNum].length})
          </div>
          {marksByPage[pageNum].map((mark) => (
            <div
              key={mark.id}
              onClick={() => onSelectMark?.(mark)}
              className={`p-2 border-b border-gray-100 hover:bg-gray-50 cursor-pointer text-sm ${
                selectedMarkId === mark.id ? 'bg-yellow-50 border-l-2 border-l-yellow-500' : ''
              }`}
            >
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs px-1.5 py-0.5 rounded bg-gray-200 text-gray-700">
                  {mark.mark_type.replace('auto_', '').replace('_', ' ')}
                </span>
                <div className="flex items-center gap-1">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      onUpdateMark(mark.id, { is_confirmed: !mark.is_confirmed });
                    }}
                    className={`text-xs px-1.5 py-0.5 rounded ${
                      mark.is_confirmed
                        ? 'bg-green-100 text-green-700 hover:bg-green-200'
                        : 'bg-amber-100 text-amber-700 hover:bg-amber-200'
                    }`}
                  >
                    {mark.is_confirmed ? (
                      <span className="inline-flex items-center gap-0.5"><Check className="h-3 w-3" /> Confirmed</span>
                    ) : (
                      <span>Confirm</span>
                    )}
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      onDeleteMark(mark.id);
                    }}
                    className="p-0.5 text-red-400 hover:text-red-600 rounded"
                    title="Delete mark"
                  >
                    <Trash2 className="h-3.5 w-3.5" />
                  </button>
                </div>
              </div>
              {mark.original_text && (
                <div className="text-xs text-gray-600 truncate mb-1" title={mark.original_text}>
                  "{mark.original_text}"
                </div>
              )}
              <RedactionReasonSelect
                value={mark.reason_code}
                onChange={(code) => onUpdateMark(mark.id, { reason_code: code })}
                reasonCodes={reasonCodes}
                className="w-full"
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default RedactionMarkList;
